import { Component, Inject, OnInit } from '@angular/core';
import { PrintProductionDto } from '../../../../../model/print-production/print-production-dto';
import {
  DimensionType,
  MaterialType,
  // DimensionType,
  // MaterialType,
  NbColorsType,
  PrintMethodType,
  // PrintMethodType,
  PrintProductTypes,
  StickerSubTypes,
  VariaSubTypes,
} from '../../../../../model/print-production/print-product-enums';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// import {PrintProductionProductOptionsService} from "../service/print-production-product-options.service";

@Component({
  selector: 'app-info-print-production-modal',
  templateUrl: './info-print-production-modal.component.html',
  styleUrls: ['./info-print-production-modal.component.css'],
})
export class InfoPrintProductionModalComponent implements OnInit {
  protected readonly NbColorsType = NbColorsType;
  defaultSecondaryColorOption: string = 'CYMK';

  printProductTypeChoices = this.mapEnumToChoices(PrintProductTypes);
  immoSubTypeChoices = this.mapEnumToChoices(StickerSubTypes);
  variaSubTypeChoices = this.mapEnumToChoices(VariaSubTypes);
  subTypeChoices: { key: string; value: any }[];
  printMethodTypeChoices = this.mapEnumToChoices(PrintMethodType);
  nbColorsTypeChoices = this.mapEnumToChoices(NbColorsType);
  materialOptions = this.mapEnumToChoices(MaterialType);
  dimensionOptions = this.mapEnumToChoices(DimensionType);
  loading: boolean = true;

  mapEnumToChoices(enumType: object) {
    return Object.entries(enumType).map(([key, value]) => ({
      key,
      value,
    }));
  }

  constructor(
    public dialogRef: MatDialogRef<InfoPrintProductionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public printProduction: PrintProductionDto
  ) {}

  ngOnInit(): void {
    if (this.printProduction.type === 'STICKER') {
      this.subTypeChoices = this.immoSubTypeChoices;
    } else if (this.printProduction.type === 'VARIA') {
      this.subTypeChoices = this.variaSubTypeChoices;
    }
    this.loading = false;
  }

  getValue(key: any, options: any[]): string {
    return options.find((o) => o.key === key)?.value || '-';
  }
}
